import React, { createContext, useContext } from "react";
import { IOrganizationProps } from "../../types/Organization";
import { IEventProps, ISmallEventProps, IEventTicketDetailsProps } from "../../types/Event";

interface RootPropsContextValue {
  organization?: IOrganizationProps;
  event?: IEventProps;
  events?: ISmallEventProps[];
  tickets?: IEventTicketDetailsProps[];
}

const RootPropsContext = createContext<RootPropsContextValue>({});

export const RootPropsProvider: React.FC<{
  children: React.ReactNode;
  value: RootPropsContextValue;
}> = ({ children, value }) => {
  return (
    <RootPropsContext.Provider value={value}>
      {children}
    </RootPropsContext.Provider>
  );
};

export const useRootProps = () => useContext(RootPropsContext);

